import { FC, PropsWithChildren } from 'react';
import { cn } from '@/utils/classNames.ts';
import AppLogo from '@/components/ui/AppLogo/AppLogo.tsx';
import { PropsWithClassName } from '@/types/PropsWithClassName';

const BrandCardSideContent: FC<PropsWithChildren<PropsWithClassName>> = ({ children, className }) => {
  return (
    <div
      className={cn(
        'grid grid-cols-2 shadow-xl rounded-2xl max-w-full w-[1048px] md:min-h-[500px] lg:min-h-[624px]',
        className
      )}
    >
      <div className="col-span-2 md:col-span-1 flex flex-col items-center justify-center gap-6 p-8 md:p-12 bg-primary rounded-l-2xl rounded-r-2xl md:rounded-r-none">
        <div className="flex flex-col items-center gap-5">
          <AppLogo.LogoOnly className="w-[70px] md:w-[110px] max-w-full" />
          <h1 className="text-white text-2xl md:text-3xl font-lato font-medium text-center leading-none whitespace-nowrap">
            Past Papers Plus
          </h1>
        </div>
      </div>
      <div className="col-span-2 md:col-span-1 flex flex-col justify-center items-center gap-4 p-4 lg:p-10">
        {children}
      </div>
    </div>
  );
};

export default BrandCardSideContent;
